export default __webpack_public_path__ + "static/media/Solar.aa0b3764.png";